<template>
  <!-- Page loading spinner -->

  <div class="page-loading active">
    <div class="page-loading-inner">
      <div class="page-spinner"></div>
      <span>Loading...</span>
      <img
        src="../../assets/img/gallery/marido-logo-no-bg.png"
        width="116"
        alt="logo"
      />
    </div>
  </div>
</template>

<script>
export default {
  name: "pageLoading",
  components: {},
};
</script>
